import { api } from '@/lib/api'
import type { DocumentRequest, DocumentRequestItem, DocumentRequestStatus } from '@riverpark/types'

export interface CreateDocumentRequestInput {
  plotId: string
  title: string
  instructions?: string
  items: { label: string }[]
  dueDate?: string
}

export async function listDocumentRequests(params?: {
  plotId?: string
  status?: DocumentRequestStatus
}) {
  const qs = new URLSearchParams()
  if (params?.plotId) qs.set('plotId', params.plotId)
  if (params?.status) qs.set('status', params.status)
  const suffix = qs.toString() ? `?${qs.toString()}` : ''
  return api.get<{ data: DocumentRequest[] }>(`/document-requests${suffix}`)
}

export async function getDocumentRequest(id: string) {
  return api.get<{ data: DocumentRequest }>(`/document-requests/${id}`)
}

export async function createDocumentRequest(input: CreateDocumentRequestInput) {
  return api.post<{ data: DocumentRequest }>('/document-requests', input)
}

export async function submitDocumentRequestItem(requestId: string, itemId: string, file: File) {
  const form = new FormData()
  form.set('file', file)
  return api.postForm<{ data: DocumentRequestItem }>(
    `/document-requests/${requestId}/items/${itemId}/submit`,
    form,
  )
}

export async function approveDocumentRequestItem(requestId: string, itemId: string, note?: string) {
  return api.post<{ data: DocumentRequestItem }>(
    `/document-requests/${requestId}/items/${itemId}/approve`,
    { note },
  )
}

export async function rejectDocumentRequestItem(requestId: string, itemId: string, note: string) {
  return api.post<{ data: DocumentRequestItem }>(
    `/document-requests/${requestId}/items/${itemId}/reject`,
    { note },
  )
}
